import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-off-page',
  templateUrl: './off-page.component.html',
  styleUrls: ['./off-page.component.css'],
})
export class OffPageComponent {
  url: string = 'seoOffpageCampaigns';

  loading: boolean = true;
  saving: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedUniverse: string = 'all';
  selectedMarket: string = 'all';
  selectedLinkType: string = 'all';
  selectedSource: string = 'all';
  selectedDestination: string = 'all';
  selectedType: string = 'all';
  selectedStatus: string = 'all';

  pendingUniverse: string = 'all';
  pendingMarket: string = 'all';
  pendingLinkType: string = 'all';
  pendingSource: string = 'all';
  pendingDestination: string = 'all';
  pendingType: string = 'all';
  pendingStatus: string = 'all';

  // ── Tabs Navigation ───────────────────────────────────────────────────────
  issuesActiveTab: string = 'all';
  oppActiveTab: string = 'all_opp';

  issuesTabs = [
    { key: 'all', label: 'All Issues', count: 48, colorClass: 'text-dark' },
    { key: 'critical', label: 'Critical', count: 9, colorClass: 'text-dark' },
    { key: 'lost', label: 'Lost Links', count: 8, colorClass: 'text-dark' },
    { key: 'broken', label: 'Broken Links', count: 6, colorClass: 'text-dark' },
    {
      key: 'misallocation',
      label: 'Misallocation',
      count: 5,
      colorClass: 'text-dark',
    },
    { key: 'toxic', label: 'Toxic / Risk', count: 7, colorClass: 'text-dark' },
    { key: 'redirects', label: 'Redirects', count: 5, colorClass: 'text-dark' },
    { key: 'other', label: 'Other', count: 8, colorClass: 'text-dark' },
  ];

  oppTabs = [
    {
      key: 'all_opp',
      label: 'All Opportunities',
      count: 62,
      colorClass: 'text-dark',
    },
    {
      key: 'link',
      label: 'Link Opportunities',
      count: 28,
      colorClass: 'text-dark',
    },
    { key: 'mention', label: 'Mentions', count: 16, colorClass: 'text-dark' },
    {
      key: 'partnership',
      label: 'Partnerships',
      count: 10,
      colorClass: 'text-dark',
    },
    {
      key: 'citation',
      label: 'Citations w/ Value',
      count: 8,
      colorClass: 'text-dark',
    },
  ];

  // ── Filter Dropdowns options ──────────────────────────────────────────────
  universes = [
    { value: 'all', label: 'All Universes' },
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  markets = [
    { value: 'all', label: 'All Markets' },
    { value: 'core_market', label: 'Core Market' },
    { value: 'growth_market', label: 'Growth Market' },
    { value: 'expansion_market', label: 'Expansion Market' },
  ];

  linkTypes = [
    { value: 'all', label: 'All Types' },
    { value: 'dofollow', label: 'Dofollow' },
    { value: 'nofollow', label: 'Nofollow' },
    { value: 'ugc', label: 'UGC' },
    { value: 'sponsored', label: 'Sponsored' },
  ];

  sources = [
    { value: 'all', label: 'All Sources' },
    { value: 'resource', label: 'Resource Page' },
    { value: 'mention', label: 'Brand Mention' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'directory', label: 'Directory' },
  ];

  destinations = [
    { value: 'all', label: 'All URLs' },
    { value: 'legal-services', label: '/legal-services/' },
    { value: 'same-day', label: '/same-day-courier-miami/' },
    { value: 'root', label: '/' },
    { value: 'courier-services', label: '/courier-services/' },
    { value: 'concierge', label: '/concierge-services/' },
  ];

  types = [
    { value: 'all', label: 'All Types' },
    { value: 'lost', label: 'Lost Backlink' },
    { value: 'broken', label: 'Broken Link (404)' },
    { value: 'misallocation', label: 'Authority Misallocation' },
    { value: 'suspicious', label: 'Suspicious Link' },
    { value: 'toxic', label: 'Toxic Pattern' },
  ];

  statuses = [
    { value: 'all', label: 'All Statuses' },
    { value: 'action', label: 'Needs Action' },
    { value: 'fix', label: 'Needs Fix' },
    { value: 'review', label: 'Under Review' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'ready', label: 'Ready for Outreach' },
  ];

  // ── Stat Cards ────────────────────────────────────────────────────────────
  stats = {
    referringDomains: { value: 312, trend: '18 vs last 30 days', up: true },
    totalBacklinks: { value: 1842, trend: '142 vs last 30 days', up: true },
    newLinks: { value: 156, trend: '28 vs last 30 days', up: true },
    lostLinks: { value: 34, trend: '9 vs last 30 days', up: false }, // Down trend is bad for lost links but here it lists up or down. Let's make it look red or green.
    domainAuthority: { value: 41, trend: '2 vs last 30 days', up: true },
    authorityHealth: { value: 72, trend: '6% vs last 30 days', up: true },
    highPriorityIssues: { value: 12, trend: '3 vs last 30 days', up: false },
  };

  // ── Selected Item ─────────────────────────────────────────────────────────
  selectedIssue: any = null;

  // ── Datasets ──────────────────────────────────────────────────────────────
  issuesList: any[] = [];
  opportunitiesList: any[] = [];

  // ── Bottom section (Charts & Distribution lists) ──────────────────────────
  netLinks = {
    net: 122,
    new: 156,
    lost: 34,
  };

  topLinkingPages = [
    { page: '/legal-services/', count: 128 },
    { page: '/same-day-courier-miami/', count: 96 },
    { page: '/courier-services/', count: 74 },
    { page: '/', count: 45 },
    { page: '/concierge-services/', count: 31 },
  ];

  anchorDistribution = {
    total: 1842,
    brand: 35,
    partialMatch: 20,
    exactMatch: 15,
    generic: 14,
    other: 8,
  };

  linkTypeDistribution = {
    total: 1842,
    dofollow: 72,
    nofollow: 22,
    ugc: 4,
    sponsored: 2,
  };

  authorityScores = [
    { label: '90+', count: 14, pct: 14 },
    { label: '70-89', count: 52, pct: 52 },
    { label: '50-69', count: 96, pct: 96 },
    { label: '30-49', count: 102, pct: 100 },
    { label: '10-29', count: 48, pct: 48 },
    { label: '<10', count: 0, pct: 0 },
  ];

  signals: any[] = [];
  recentLocalActivity: any[] = [];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.loadCampaigns();
  }

  loadCampaigns(): void {
    this.loading = true;
    // Call endpoint as fallback or to test connection
    this.dataService.getData(this.url).subscribe(
      () => {
        this.buildStaticData();
        this.loading = false;
      },
      () => {
        this.buildStaticData();
        this.loading = false;
      },
    );
  }

  buildStaticData(): void {
    // ── Issues Queue ────────────────────────────────────────────────────────
    this.issuesList = [
      {
        selectedType: 'issue',
        type: 'Lost Backlink',
        domain: 'lawlogix.com',
        destinationUrl: '/legal-services/',
        details: 'High',
        status: 'Needs Action',
        recommendedAction: 'Recheck',
        date: 'May 18, 2025',
        // Details
        sourceType: 'Resource Page',
        anchorText: 'legal courier services',
        linkType: 'Dofollow',
        firstDetected: 'Apr 28, 2025',
        lastChecked: 'May 18, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'High',
        da: 68,
        relevance: 'High',
        issueDetails:
          'The link previously existed on a resource page about legal support services but is no longer active.',
        aiRationale:
          'This domain is relevant to the legal industry and the link previously passed authority to an important service page.',
        actionCenter: {
          selectedAction: 'Reclaim Lost Link',
          targetSource: 'lawlogix.com',
          targetUrl: '/legal-services/',
          element: 'Resource Link',
          decisionOrigin: 'AI Detected',
          currentText:
            'The link previously existed on a resource page but is no longer active.',
          proposedText:
            'Reach out to the site owner to restore the link to our current resource page:\nhttps://courierandbeyond.com/legal-services/',
          aiRecommendation:
            'This domain is relevant, authoritative and previously linked to our most important resource page. Restoring this link can recover valuable authority.',
          aiConfidence: 87,
          riskLevel: 'Low',
          executionMode: 'Human Approval Required',
        },
      },
      {
        selectedType: 'issue',
        type: 'Broken Link (404)',
        domain: 'miamilawgroup.com',
        destinationUrl: '/old-legal-courier/...',
        details: 'High',
        status: 'Needs Fix',
        recommendedAction: 'Redirect',
        date: 'May 18, 2025',
        // Details
        sourceType: 'Resource Page',
        anchorText: 'legal couriers miami',
        linkType: 'Dofollow',
        firstDetected: 'May 01, 2025',
        lastChecked: 'May 18, 2025',
        statusClass: 'text-danger fw-bold',
        impact: 'High',
        da: 45,
        relevance: 'High',
        issueDetails:
          'The referring page links to an old path /old-legal-courier/ which returns a 404 error.',
        aiRationale:
          'Providing a redirect from /old-legal-courier/ to the live /legal-services/ will preserve the existing user experience and domain authority.',
        actionCenter: {
          selectedAction: 'Setup 301 Redirect',
          targetSource: 'miamilawgroup.com',
          targetUrl: '/old-legal-courier/...',
          element: '301 Redirect',
          decisionOrigin: 'AI Detected',
          currentText: 'Dest URL /old-legal-courier/ returns 404 NOT FOUND.',
          proposedText:
            'Redirect /old-legal-courier/ to /legal-services/ via web server configuration.',
          aiRecommendation:
            'Mapping old URLs to their newer active equivalent redirects juice and assists indexing.',
          aiConfidence: 94,
          riskLevel: 'Low',
          executionMode: 'Auto Redirect Setup',
        },
      },
      {
        selectedType: 'issue',
        type: 'Authority Misallocation',
        domain: 'conciergessn.org',
        destinationUrl: '/legal-services/',
        details: 'Medium',
        status: 'Under Review',
        recommendedAction: 'Review Destination',
        date: 'May 17, 2025',
        // Details
        sourceType: 'Directory Listing',
        anchorText: 'concierge support services',
        linkType: 'Dofollow',
        firstDetected: 'Feb 14, 2025',
        lastChecked: 'May 17, 2025',
        statusClass: 'text-primary fw-bold',
        impact: 'Medium',
        da: 52,
        relevance: 'Medium',
        issueDetails:
          'The anchor text discusses concierge services, but the link points directly to the general legal services page.',
        aiRationale:
          'Re-evaluating target destinations to better match the keyword anchor text improves context relevance.',
        actionCenter: {
          selectedAction: 'Re-Route Target URL',
          targetSource: 'conciergessn.org',
          targetUrl: '/legal-services/',
          element: 'Anchor Mapping',
          decisionOrigin: 'AI Audit',
          currentText:
            'Link points to /legal-services/ with anchor text "concierge support".',
          proposedText:
            'Request partner to change the destination link to /concierge-services/.',
          aiRecommendation:
            'Coherence in link targeting increases search optimization and domain authority mapping value.',
          aiConfidence: 89,
          riskLevel: 'Low',
          executionMode: 'Manual outreach requested',
        },
      },
      {
        selectedType: 'issue',
        type: 'Lost Backlink',
        domain: 'bizjournals.com',
        destinationUrl: '/same-day-courier-miami/',
        details: 'Medium',
        status: 'Needs Action',
        recommendedAction: 'Recheck',
        date: 'May 17, 2025',
        sourceType: 'News Article',
        anchorText: 'same-day couriers in miami',
        linkType: 'Dofollow',
        firstDetected: 'Mar 10, 2025',
        lastChecked: 'May 17, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'Medium',
        da: 74,
        relevance: 'High',
        issueDetails:
          'Daily scan reported that our backlink in the Miami article could not be detected in the page DOM.',
        aiRationale:
          'Authoritative news sites have high Page Authority. Contact editor to query link status.',
        actionCenter: {
          selectedAction: 'Editorial Inquiry',
          targetSource: 'bizjournals.com',
          targetUrl: '/same-day-courier-miami/',
          element: 'News Link',
          decisionOrigin: 'Automation Engine',
          currentText: 'Link not detected in news article body.',
          proposedText:
            'Contact editor at bizjournals to verify if link was removed due to site design refresh.',
          aiRecommendation:
            'Verifying with editorial teams saves links before search crawlers index the removal.',
          aiConfidence: 91,
          riskLevel: 'Low',
          executionMode: 'Manual Team Outreach',
        },
      },
      {
        selectedType: 'issue',
        type: 'Broken Link (Redirect Chain)',
        domain: 'legalnews.com',
        destinationUrl: '/legal-services/',
        details: 'Medium',
        status: 'Needs Fix',
        recommendedAction: 'Redirect',
        date: 'May 16, 2025',
        sourceType: 'Resource Page',
        anchorText: 'legal couriers',
        linkType: 'Dofollow',
        firstDetected: 'Jan 10, 2025',
        lastChecked: 'May 16, 2025',
        statusClass: 'text-danger fw-bold',
        impact: 'Medium',
        da: 61,
        relevance: 'High',
        issueDetails:
          'Link path goes through multiple redirects before landing on the final destination page /legal-services/.',
        aiRationale:
          'Removing intermediate redirect chains improves page load latency and preserves maximum index juice value.',
        actionCenter: {
          selectedAction: 'Resolve Redirect Chain',
          targetSource: 'legalnews.com',
          targetUrl: '/legal-services/',
          element: 'Redirect Chain',
          decisionOrigin: 'System Audit',
          currentText: 'Link redirects: source -> middle-link -> final.',
          proposedText:
            'Request referring site to link directly to the final destination URL: /legal-services/.',
          aiRecommendation:
            'Shortening link paths reduces page hop delay and enhances indexing efficiency.',
          aiConfidence: 85,
          riskLevel: 'Low',
          executionMode: 'Pitch direct replacement',
        },
      },
      {
        selectedType: 'issue',
        type: 'Suspicious Link',
        domain: 'cheapdirectoryseo.net',
        destinationUrl: '/',
        details: 'High',
        status: 'Under Review',
        recommendedAction: 'Disavow',
        date: 'May 16, 2025',
        sourceType: 'Directory Page',
        anchorText: 'courier & beyond',
        linkType: 'Dofollow',
        firstDetected: 'May 15, 2025',
        lastChecked: 'May 16, 2025',
        statusClass: 'text-primary fw-bold',
        impact: 'High',
        da: 12,
        relevance: 'Low',
        issueDetails:
          'Unsolicited low-authority link with a spam score above 45%. Undergoing security review.',
        aiRationale:
          'Spammy backlinks can invoke search algorithm penalties. Recommend monitoring or disavowing if profile turns bad.',
        actionCenter: {
          selectedAction: 'Queue for Disavow List',
          targetSource: 'cheapdirectoryseo.net',
          targetUrl: '/',
          element: 'Disavow File',
          decisionOrigin: 'Spam Detector',
          currentText: 'Spam score 48%. Low relevance directory.',
          proposedText:
            'Add cheapdirectoryseo.net to our Google Disavow text file registry.',
          aiRecommendation:
            'Disavowing toxic domains early protects the search authority and trustworthiness of the root workspace.',
          aiConfidence: 96,
          riskLevel: 'Low',
          executionMode: 'Automatic Queue',
        },
      },
      {
        selectedType: 'issue',
        type: 'Toxic Pattern',
        domain: 'various (12 domains)',
        destinationUrl: 'various',
        details: 'High',
        status: 'Needs Review',
        recommendedAction: 'Report',
        date: 'May 15, 2025',
        sourceType: 'Spam Network',
        anchorText: 'generic terms',
        linkType: 'Dofollow',
        firstDetected: 'May 12, 2025',
        lastChecked: 'May 15, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'High',
        da: 8,
        relevance: 'Low',
        issueDetails:
          'Twelve suspicious domains with duplicate layout structures linked to the root page within 48 hours.',
        aiRationale:
          'Bulk listing links on duplicate domains represents a typical PBN footprint. Quick action is needed.',
        actionCenter: {
          selectedAction: 'Bulk Disavow Action',
          targetSource: 'various (12 domains)',
          targetUrl: 'various',
          element: 'PBN Pattern',
          decisionOrigin: 'AI Pattern Match',
          currentText: '12 new backlinks from identical IP structures.',
          proposedText:
            'Build bulk domain disavow pattern command for all 12 detected spam network URLs.',
          aiRecommendation:
            'Unlinking toxic networks halts search indexing penalty risks.',
          aiConfidence: 98,
          riskLevel: 'Low',
          executionMode: 'Approve pattern',
        },
      },
      {
        selectedType: 'issue',
        type: 'Lost Backlink',
        domain: 'courtofficialnet.org',
        destinationUrl: '/legal-services/',
        details: 'Medium',
        status: 'Needs Action',
        recommendedAction: 'Recheck',
        date: 'May 15, 2025',
        sourceType: 'Resource Page',
        anchorText: 'official court runners',
        linkType: 'Dofollow',
        firstDetected: 'Feb 10, 2025',
        lastChecked: 'May 15, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'Medium',
        da: 38,
        relevance: 'High',
        issueDetails:
          'Link was reported missing on courtofficialnet.org resource directories index table.',
        aiRationale:
          'Medium authority page. Email contact to inquire if page directory has moved.',
        actionCenter: {
          selectedAction: 'Verify Link Resource',
          targetSource: 'courtofficialnet.org',
          targetUrl: '/legal-services/',
          element: 'Directory Link',
          decisionOrigin: 'AI Detected',
          currentText: 'Link not detected on directory page.',
          proposedText:
            'Query directory administrator for information on missing link.',
          aiRecommendation:
            'Polite outreach will help maintain link state if it was accidentally omitted in audit.',
          aiConfidence: 82,
          riskLevel: 'Low',
          executionMode: 'Manual Outreach',
        },
      },
    ];

    // ── Opportunities Queue ──────────────────────────────────────────────────
    this.opportunitiesList = [
      {
        selectedType: 'opportunity',
        type: 'Link Opportunity',
        domain: 'floridabar.org',
        sourceType: 'Resource Page',
        opportunity: 'Link Opportunity',
        authority: 78,
        relevance: 'High',
        status: 'Qualified',
        priority: 'High',
        destinationUrl: '/legal-services/',
        anchorText: 'florida legal couriers',
        linkType: 'Dofollow',
        firstDetected: 'Apr 28, 2025',
        lastChecked: 'May 18, 2025',
        statusClass: 'text-success fw-bold',
        impact: 'High',
        da: 78,
        issueDetails:
          'Florida Bar directory has a legal runners section with missing links to regional couriers.',
        aiRationale:
          'Very high DA (78) domain in the legal space. An active link here directly boosts /legal-services/.',
        actionCenter: {
          selectedAction: 'Pitch Resource Inclusion',
          targetSource: 'floridabar.org',
          targetUrl: '/legal-services/',
          element: 'Directory Listing',
          decisionOrigin: 'AI Recommendation',
          currentText: 'Resource list lacks Florida courier representation.',
          proposedText:
            'Submit Miami legal courier services details directly to the Florida Bar section web editor.',
          aiRecommendation:
            'This site is highly relevant to our legal services segment. Highly recommended.',
          aiConfidence: 96,
          riskLevel: 'Low',
          executionMode: 'Human Review Needed',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Unlinked Mention',
        domain: 'americanbar.org',
        sourceType: 'Brand Mention',
        opportunity: 'Unlinked Mention',
        authority: 72,
        relevance: 'High',
        status: 'Ready for Outreach',
        priority: 'High',
        destinationUrl: '/legal-services/',
        anchorText: 'Courier & Beyond',
        linkType: 'Dofollow',
        firstDetected: 'May 12, 2025',
        lastChecked: 'May 18, 2025',
        statusClass: 'text-success fw-bold',
        impact: 'High',
        da: 72,
        issueDetails:
          'American Bar Association article mentions "Courier & Beyond" as a top courier choice but doesn\'t link to us.',
        aiRationale:
          'An existing unlinked mention is the highest conversion prospect. Pitching a direct link has a 60%+ success chance.',
        actionCenter: {
          selectedAction: 'Send Link Request',
          targetSource: 'americanbar.org',
          targetUrl: '/legal-services/',
          element: 'Unlinked Mention',
          decisionOrigin: 'Mention Alert',
          currentText:
            'Brand name "Courier & Beyond" exists without clickable URL.',
          proposedText:
            'Reach out to author to offer high-relevance destination URL pointing to our legal site.',
          aiRecommendation:
            'Authors are highly open to linking brand names if a robust resources page is provided.',
          aiConfidence: 93,
          riskLevel: 'Low',
          executionMode: 'Automated outreach template',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Link Opportunity',
        domain: 'courthouselibrary.org',
        sourceType: 'Resource Page',
        opportunity: 'Link Opportunity',
        authority: 65,
        relevance: 'High',
        status: 'Ready for Outreach',
        priority: 'High',
        destinationUrl: '/legal-services/',
        anchorText: 'legal document delivery',
        linkType: 'Dofollow',
        firstDetected: 'May 06, 2025',
        lastChecked: 'May 18, 2025',
        statusClass: 'text-success fw-bold',
        impact: 'High',
        da: 65,
        issueDetails:
          'Courthouse Library resources page is list-oriented and accepts local legal logistics site pitches.',
        aiRationale:
          'Great DA 65 citation. High niche alignment to legal intake logistics.',
        actionCenter: {
          selectedAction: 'Submit Directory Request',
          targetSource: 'courthouselibrary.org',
          targetUrl: '/legal-services/',
          element: 'Directory Link',
          decisionOrigin: 'AI Recommendation',
          currentText: 'Our service is not listed on local reference index.',
          proposedText:
            'Apply to local legal support directory using office location and address credentials.',
          aiRecommendation:
            'This link provides localized authority, improving regional search rankings.',
          aiConfidence: 89,
          riskLevel: 'Low',
          executionMode: 'Send form automatically',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Partnership Opportunity',
        domain: 'miamihels.org',
        sourceType: 'Partnership',
        opportunity: 'Partnership Opportunity',
        authority: 62,
        relevance: 'Medium',
        status: 'Identified',
        priority: 'Medium',
        destinationUrl: '/legal-services/',
        anchorText: 'miami legal runners',
        linkType: 'Dofollow',
        firstDetected: 'May 14, 2025',
        lastChecked: 'May 17, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'Medium',
        da: 62,
        issueDetails:
          'Non-profit legal aid organization which lists corporate delivery sponsors on their site.',
        aiRationale:
          'Corporate sponsorship provides powerful backlinks (.org) and increases local trust factors.',
        actionCenter: {
          selectedAction: 'Inquire Sponsorship',
          targetSource: 'miamihels.org',
          targetUrl: '/legal-services/',
          element: 'Sponsor Backlink',
          decisionOrigin: 'AI Outreach Broker',
          currentText: 'Sponsor directory has openings for courier partners.',
          proposedText:
            'Send corporate sponsorship inquiry offering delivery discount services in trade for link.',
          aiRecommendation:
            'In-kind sponsorships have high success rate and create high-strength .org links.',
          aiConfidence: 88,
          riskLevel: 'Low',
          executionMode: 'Draft Partnership Pitch',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Citation with Value',
        domain: 'yelp.com/business',
        sourceType: 'Directory Page',
        opportunity: 'Citation with Value',
        authority: 61,
        relevance: 'High',
        status: 'Qualified',
        priority: 'Medium',
        destinationUrl: '/legal-services/',
        anchorText: 'courier service details',
        linkType: 'Nofollow',
        firstDetected: 'May 01, 2025',
        lastChecked: 'May 17, 2025',
        statusClass: 'text-success fw-bold',
        impact: 'Medium',
        da: 61,
        issueDetails:
          'Yelp listing profile has missing or incomplete service category data descriptions.',
        aiRationale:
          'Consistent directory listings assist GBP validation. Ensure details are fully updated.',
        actionCenter: {
          selectedAction: 'Sync Citation Details',
          targetSource: 'yelp.com/business',
          targetUrl: '/legal-services/',
          element: 'Yelp API Sync',
          decisionOrigin: 'NAP Check Engine',
          currentText: 'Yelp profile lacks detailed category associations.',
          proposedText:
            'Push detailed service descriptions and target link to Yelp business portal API.',
          aiRecommendation:
            'Updating NAP citations decreases search rank inconsistency risks.',
          aiConfidence: 95,
          riskLevel: 'Low',
          executionMode: 'Automatic API Push',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Unlinked Mention',
        domain: 'legaltechnews.com',
        sourceType: 'Brand Mention',
        opportunity: 'Unlinked Mention',
        authority: 58,
        relevance: 'Medium',
        status: 'Identified',
        priority: 'Medium',
        destinationUrl: '/legal-services/',
        anchorText: 'Courier & Beyond fleet',
        linkType: 'Dofollow',
        firstDetected: 'May 10, 2025',
        lastChecked: 'May 16, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'Medium',
        da: 58,
        issueDetails:
          'Industry news article reviews courier software and mentions our fleet without backlink.',
        aiRationale:
          'Relevance is high. Inquiring with the author should easily convert to a link.',
        actionCenter: {
          selectedAction: 'Contact Author',
          targetSource: 'legaltechnews.com',
          targetUrl: '/legal-services/',
          element: 'Author Outreach',
          decisionOrigin: 'Mention Crawler',
          currentText: 'Unlinked mention in tech section.',
          proposedText:
            'Email writer stating appreciation for mention and suggesting linking resource URL.',
          aiRecommendation:
            'Polite appreciation pitches convert unlinked references efficiently.',
          aiConfidence: 87,
          riskLevel: 'Low',
          executionMode: 'Automated Schedule',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Link Opportunity',
        domain: 'logisticsmgmt.com',
        sourceType: 'Resource Page',
        opportunity: 'Link Opportunity',
        authority: 56,
        relevance: 'Medium',
        status: 'Contacted',
        priority: 'Medium',
        destinationUrl: '/legal-services/',
        anchorText: 'regional couriers list',
        linkType: 'Dofollow',
        firstDetected: 'May 11, 2025',
        lastChecked: 'May 16, 2025',
        statusClass: 'text-warning fw-bold',
        impact: 'Medium',
        da: 56,
        issueDetails:
          'Logistics management tips page accepts submissions for local delivery companies listing.',
        aiRationale:
          'Industry portal with good domain authority. Solid backlink candidate.',
        actionCenter: {
          selectedAction: 'Followup Request',
          targetSource: 'logisticsmgmt.com',
          targetUrl: '/legal-services/',
          element: 'Editorial Listing',
          decisionOrigin: 'AI Scheduler',
          currentText: 'Outreach email sent 5 days ago. No bounce.',
          proposedText:
            'Send automated reminder follow-up email to logistics management editor.',
          aiRecommendation:
            'Following up increases click-through rates and editorial response indices by 18%.',
          aiConfidence: 84,
          riskLevel: 'Low',
          executionMode: 'Check reminders',
        },
      },
      {
        selectedType: 'opportunity',
        type: 'Partnership Opportunity',
        domain: 'hotelconcierge.com',
        sourceType: 'Partnership',
        opportunity: 'Partnership Opportunity',
        authority: 55,
        relevance: 'High',
        status: 'Identified',
        priority: 'Medium',
        destinationUrl: '/legal-services/',
        anchorText: 'concierge runners group',
        linkType: 'Dofollow',
        firstDetected: 'May 13, 2025',
        lastChecked: 'May 15, 2025',
        statusClass: 'text-success fw-bold',
        impact: 'Medium',
        da: 55,
        issueDetails:
          'Local hospitality forum accepting member guest post articles with backlinks.',
        aiRationale:
          'Posting informative content is an excellent way to capture direct guest post backlinks.',
        actionCenter: {
          selectedAction: 'Pitch Article Idea',
          targetSource: 'hotelconcierge.com',
          targetUrl: '/legal-services/',
          element: 'Guest Article',
          decisionOrigin: 'AI Recommendation',
          currentText:
            'Identified hotel concierge portal accepts guest content.',
          proposedText:
            'Submit article outline "Maximizing Guest Satisfaction with Professional Errand Runners".',
          aiRecommendation:
            'Drafting structured headlines and useful advice maps to a high publication approval rate.',
          aiConfidence: 91,
          riskLevel: 'Low',
          executionMode: 'Prepare Outline Draft',
        },
      },
    ];

    // ── Cross-Module Signals ───────────────────────────────────────────────
    this.signals = [
      {
        signal: 'Authority Misallocation Detected',
        to: 'URL Mapping',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'External Authority Landing on Weekly Connected URL',
        to: 'Internal Links',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'Local Page Missing Backlinks',
        to: 'Local SEO',
        status: 'Sent',
        date: 'May 17',
      },
      {
        signal: 'Broken Backlink (404)',
        to: 'Technical QA',
        status: 'Open',
        date: 'May 17',
      },
      {
        signal: 'Authority Asset Needed',
        to: 'MediaRoom',
        status: 'Open',
        date: 'May 16',
      },
    ];

    // ── Recent Activity ─────────────────────────────────────────────────────
    this.recentLocalActivity = [
      {
        text: 'Acquired link from floridabar.org',
        date: 'May 18, 2025 10:24 AM',
        actor: 'AI',
      },
      {
        text: 'Recovered link from bizjournals.com',
        date: 'May 17, 2025 03:41 PM',
        actor: 'Felipe',
      },
      {
        text: 'Unlinked mention found on americanbar.org',
        date: 'May 17, 2025 09:15 AM',
        actor: 'AI',
      },
      {
        text: 'Lost link detected from lawlogix.com',
        date: 'May 16, 2025 11:05 AM',
        actor: 'AI',
      },
    ];

    // Select the first issue initially
    if (this.issuesList.length > 0) {
      this.selectIssue(this.issuesList[0]);
    }
  }

  // ── Filters & Getters ─────────────────────────────────────────────────────
  getFilteredIssues(): any[] {
    return this.issuesList.filter((item) => {
      // Universe
      if (
        this.selectedUniverse !== 'all' &&
        item.universe &&
        item.universe !== this.selectedUniverse
      ) {
        return false;
      }
      // Market
      if (
        this.selectedMarket !== 'all' &&
        item.marketPriority &&
        item.marketPriority !== this.selectedMarket
      ) {
        return false;
      }
      // Link Type
      if (
        this.selectedLinkType !== 'all' &&
        item.linkType &&
        item.linkType.toLowerCase() !== this.selectedLinkType
      ) {
        return false;
      }
      // Authority Source
      if (
        this.selectedSource !== 'all' &&
        item.sourceType &&
        !item.sourceType.toLowerCase().includes(this.selectedSource)
      ) {
        return false;
      }
      // Destination URL
      if (
        this.selectedDestination !== 'all' &&
        item.destinationUrl &&
        !item.destinationUrl.includes(this.selectedDestination)
      ) {
        return false;
      }
      // Opportunity / Issue Type
      if (
        this.selectedType !== 'all' &&
        item.type &&
        !item.type.toLowerCase().includes(this.selectedType)
      ) {
        return false;
      }
      // Status
      if (
        this.selectedStatus !== 'all' &&
        item.status &&
        !item.status.toLowerCase().includes(this.selectedStatus)
      ) {
        return false;
      }

      // Tab Specific filters
      if (this.issuesActiveTab === 'critical') {
        return item.details === 'High';
      } else if (this.issuesActiveTab === 'lost') {
        return item.type === 'Lost Backlink';
      } else if (this.issuesActiveTab === 'broken') {
        return item.type.includes('Broken');
      } else if (this.issuesActiveTab === 'misallocation') {
        return item.type.includes('Misallocation');
      } else if (this.issuesActiveTab === 'toxic') {
        return item.type.includes('Toxic') || item.type.includes('Suspicious');
      } else if (this.issuesActiveTab === 'redirects') {
        return item.recommendedAction.includes('Redirect');
      }

      return true;
    });
  }

  getFilteredOpportunities(): any[] {
    return this.opportunitiesList.filter((item) => {
      // Universe
      if (
        this.selectedUniverse !== 'all' &&
        item.universe &&
        item.universe !== this.selectedUniverse
      ) {
        return false;
      }
      // Market
      if (
        this.selectedMarket !== 'all' &&
        item.marketPriority &&
        item.marketPriority !== this.selectedMarket
      ) {
        return false;
      }
      // Link Type
      if (
        this.selectedLinkType !== 'all' &&
        item.linkType &&
        item.linkType.toLowerCase() !== this.selectedLinkType
      ) {
        return false;
      }
      // Authority Source
      if (
        this.selectedSource !== 'all' &&
        item.sourceType &&
        !item.sourceType.toLowerCase().includes(this.selectedSource)
      ) {
        return false;
      }
      // Destination URL
      if (
        this.selectedDestination !== 'all' &&
        item.destinationUrl &&
        !item.destinationUrl.includes(this.selectedDestination)
      ) {
        return false;
      }
      // Opportunity / Issue Type
      if (
        this.selectedType !== 'all' &&
        item.type &&
        !item.type.toLowerCase().includes(this.selectedType)
      ) {
        return false;
      }
      // Status
      if (
        this.selectedStatus !== 'all' &&
        item.status &&
        !item.status.toLowerCase().includes(this.selectedStatus)
      ) {
        return false;
      }

      // Tab Specific filters
      if (this.oppActiveTab === 'link') {
        return item.type === 'Link Opportunity';
      } else if (this.oppActiveTab === 'mention') {
        return item.type === 'Unlinked Mention';
      } else if (this.oppActiveTab === 'partnership') {
        return item.type === 'Partnership Opportunity';
      } else if (this.oppActiveTab === 'citation') {
        return item.type.includes('Citation');
      }

      return true;
    });
  }

  onFilterChange(): void {
    this.selectedUniverse = this.pendingUniverse;
    this.selectedMarket = this.pendingMarket;
    this.selectedLinkType = this.pendingLinkType;
    this.selectedSource = this.pendingSource;
    this.selectedDestination = this.pendingDestination;
    this.selectedType = this.pendingType;
    this.selectedStatus = this.pendingStatus;

    this.updateTabCounts();
    const filteredIssues = this.getFilteredIssues();
    const filteredOpps = this.getFilteredOpportunities();

    if (filteredIssues.length > 0) {
      this.selectIssue(filteredIssues[0]);
    } else if (filteredOpps.length > 0) {
      this.selectIssue(filteredOpps[0]);
    } else {
      this.selectedIssue = null;
    }
  }

  updateTabCounts(): void {
    const baseFilterIssues = (tabKey: string) => {
      return this.issuesList.filter((item) => {
        if (
          this.selectedUniverse !== 'all' &&
          item.universe &&
          item.universe !== this.selectedUniverse
        )
          return false;
        if (
          this.selectedMarket !== 'all' &&
          item.marketPriority &&
          item.marketPriority !== this.selectedMarket
        )
          return false;
        if (
          this.selectedLinkType !== 'all' &&
          item.linkType &&
          item.linkType.toLowerCase() !== this.selectedLinkType
        )
          return false;

        if (tabKey === 'critical') return item.details === 'High';
        if (tabKey === 'lost') return item.type === 'Lost Backlink';
        if (tabKey === 'broken') return item.type.includes('Broken');
        if (tabKey === 'misallocation')
          return item.type.includes('Misallocation');
        if (tabKey === 'toxic')
          return (
            item.type.includes('Toxic') || item.type.includes('Suspicious')
          );
        if (tabKey === 'redirects')
          return item.recommendedAction.includes('Redirect');
        return true;
      }).length;
    };

    const baseFilterOpps = (tabKey: string) => {
      return this.opportunitiesList.filter((item) => {
        if (
          this.selectedUniverse !== 'all' &&
          item.universe &&
          item.universe !== this.selectedUniverse
        )
          return false;
        if (
          this.selectedMarket !== 'all' &&
          item.marketPriority &&
          item.marketPriority !== this.selectedMarket
        )
          return false;
        if (
          this.selectedLinkType !== 'all' &&
          item.linkType &&
          item.linkType.toLowerCase() !== this.selectedLinkType
        )
          return false;

        if (tabKey === 'link') return item.type === 'Link Opportunity';
        if (tabKey === 'mention') return item.type === 'Unlinked Mention';
        if (tabKey === 'partnership')
          return item.type === 'Partnership Opportunity';
        if (tabKey === 'citation') return item.type.includes('Citation');
        return true;
      }).length;
    };

    this.issuesTabs[0].count = baseFilterIssues('all');
    this.issuesTabs[1].count = baseFilterIssues('critical');
    this.issuesTabs[2].count = baseFilterIssues('lost');
    this.issuesTabs[3].count = baseFilterIssues('broken');
    this.issuesTabs[4].count = baseFilterIssues('misallocation');
    this.issuesTabs[5].count = baseFilterIssues('toxic');
    this.issuesTabs[6].count = baseFilterIssues('redirects');
    this.issuesTabs[7].count = baseFilterIssues('other');

    this.oppTabs[0].count = baseFilterOpps('all_opp');
    this.oppTabs[1].count = baseFilterOpps('link');
    this.oppTabs[2].count = baseFilterOpps('mention');
    this.oppTabs[3].count = baseFilterOpps('partnership');
    this.oppTabs[4].count = baseFilterOpps('citation');
  }

  setIssuesTab(key: string): void {
    this.issuesActiveTab = key;
    const list = this.getFilteredIssues();
    if (list.length > 0) {
      this.selectIssue(list[0]);
    }
  }

  setOppTab(key: string): void {
    this.oppActiveTab = key;
    const list = this.getFilteredOpportunities();
    if (list.length > 0) {
      this.selectIssue(list[0]);
    }
  }

  // ── Selection ─────────────────────────────────────────────────────────────
  selectIssue(issue: any): void {
    this.selectedIssue = issue;
  }

  // ── Actions ───────────────────────────────────────────────────────────────
  approveAction(): void {
    this.messageService.add(
      'Action approved and queued for implementation.',
      'success',
    );
  }

  rejectAction(): void {
    this.messageService.add('Action rejected.', 'info');
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  getStatusClass(status: string): string {
    const map: Record<string, string> = {
      'Needs Action': 'bg-warning-light text-warning',
      'Needs Fix': 'bg-danger-light text-danger',
      'Under Review': 'bg-primary-light text-primary',
      'Needs Review': 'bg-warning-light text-warning',
      Qualified: 'bg-success-light text-success',
      'Ready for Outreach': 'bg-primary-light text-primary',
      Identified: 'bg-dark-light text-dark',
      Contacted: 'bg-warning-light text-warning',
    };
    return map[status] || 'text-dark';
  }

  getStatusClassTwo(status: string): string {
    const map: Record<string, string> = {
      'Needs Action': 'text-warning',
      'Needs Fix': 'text-danger',
      'Under Review': 'text-primary',
      'Needs Review': 'text-warning',
      Qualified: 'text-success',
      'Ready for Outreach': 'text-primary',
      Identified: 'text-dark',
      Contacted: 'text-warning',
    };
    return map[status] || 'text-dark';
  }

  getStatusBadgeClass(status: string): string {
    const map: Record<string, string> = {
      'Needs Action': 'bg-warning-light text-warning',
      'Needs Fix': 'bg-danger-light text-danger',
      'Under Review': 'bg-primary-light text-primary',
      'Needs Review': 'bg-warning-light text-warning',
      Qualified: 'bg-success-light text-success',
      'Ready for Outreach': 'bg-primary-light text-primary',
      Identified: 'bg-dark-light text-dark',
      Contacted: 'bg-warning-light text-warning',
    };
    return map[status] || 'bg-light text-dark';
  }

  getPriorityClass(priority: string): string {
    const map: Record<string, string> = {
      High: 'bg-danger-light text-danger',
      Medium: 'bg-warning-light text-warning',
      Low: 'bg-success-light text-success',
    };
    return map[priority] || 'bg-light text-dark';
  }

  getSignalStatusClass(status: string): string {
    const map: Record<string, string> = {
      Sent: 'bg-success-light text-success',
      Open: 'bg-warning-light text-warning',
      Monitoring: 'bg-primary-light text-primary',
    };
    return map[status] || 'bg-light text-dark';
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }
}
